/** @format */

import React, { useContext, useMemo } from "react";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import { fade } from "@material-ui/core/styles";
import {
  IconButton,
  makeStyles,
  Tooltip,
  Badge,
  MenuItem,
  Menu,
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import NotesIcon from "@material-ui/icons/Notes";

import AccountCircle from "@material-ui/icons/AccountCircle";
import MailIcon from "@material-ui/icons/Mail";

import clsx from "clsx";

import { useHistory } from "react-router-dom";
import UserContext from "../../context/Globales/UserContext";
import { AuthContext } from "../../context/Globales/AuthContext";
import { types } from "../../context/types";

import { DecodificanString } from "../../helpers/Codifican";
import { isMobile } from "react-device-detect";

import ArrowBackIcon from "@material-ui/icons/ArrowBack";

const drawerWidth = 310;

const useStyle = makeStyles((theme) => ({
  appBar: {
    zIndex: theme.zIndex.drawer + 1,

    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  hide: {
    display: "none",
  },
  grow: {
    flexGrow: 1,
  },

  title: {
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "block",
    },
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    "&:hover": {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(3),
      width: "auto",
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputRoot: {
    color: "inherit",
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "20ch",
    },
  },
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
  },
  sectionMobile: {
    display: "flex",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },

  colorIconos: {
    backgroundColor: theme.palette.greyFondo.main,
  },
}));

const NavBar = ({ open, handleDrawerOpen }) => {
  const NomberUser = DecodificanString(
    JSON.parse(localStorage.getItem("name"))
  );
  const { dispatch } = useContext(AuthContext);
  const { DataProducts } = useContext(UserContext);
  const userContext = useContext(UserContext);

  const history = useHistory();

  const classes = useStyle();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);
  const [OpenLoading, setOpenLoading] = React.useState(false);
  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const id = JSON.parse(localStorage.getItem("id"));
  const Login = JSON.parse(localStorage.getItem("login"));
  //const DataProductss = JSON.parse(localStorage.getItem('ListProducts'));
  const DataUrl = DecodificanString(
    JSON.parse(localStorage.getItem("urlBaseHome"))
  );

  const dataSetConditions = JSON.parse(
    localStorage.getItem("setConditionsProducts")
  );

  const DataUrlLink =
    DataUrl + "?SKL=" + JSON.parse(localStorage.getItem("skl"));

  useMemo(() => {
    if (dataSetConditions) {
      userContext.getProducts(id, Login);
    }
  }, []);

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const RedirigirSoporte = (e) => {
    history.push("Soporte");
  };

  const handleLogout = (e) => {
    setOpenLoading(true);

    localStorage.setItem("autenticadoTwo", JSON.stringify(false));

    setTimeout(() => {
      localStorage.clear();

      return (
        JSON.parse(localStorage.getItem("user")) || {
          logged: false,
        }
      );
    }, 1500);

    dispatch({
      type: types.AuthLogout,
    });

    setOpenLoading(false);
  };

  const handleLogoutDos = (e) => {
    setOpenLoading(true);
    localStorage.setItem("autenticadoTwo", JSON.stringify("retorna"));
    if (DataProducts) {
      // if (DataUrl){
      //   window.location.href = `${DataUrlLink}`;
      // }
    }

    setTimeout(() => {
      localStorage.clear();
    }, 1500);

    dispatch({
      type: types.AuthLogout,
    });

    //localStorage.clear();

    setOpenLoading(false);
  };

  const handleLogoutProducts = () => {
    setOpenLoading(true);

    localStorage.setItem("setConditionsProducts", JSON.stringify(false));
    if (DataProducts) {
      localStorage.setItem("autenticadoTwo", JSON.stringify("retorna"));
      //userContext.postLogoutAll(id, Login);

      if (DataUrl) {
        window.location.href = `${DataUrlLink}`;
      }
    }
    // localStorage.clear();
    setTimeout(() => {
      // localStorage.clear();

      return (
        JSON.parse(localStorage.getItem("user")) || {
          logged: false,
        }
      );
    }, 1500);

    dispatch({
      type: types.AuthLogout,
    });

    setOpenLoading(false);
  };
  // const LimpiarListaProducts =()=>{
  //   localStorage.removeItem('ListProducts');
  // }

  const handleLogoutUrl = (e) => {
    setOpenLoading(true);
    localStorage.setItem("autenticadoTwo", JSON.stringify("retorna"));
    // window.location.href=`${DataUrlLink}`

    if (DataUrl) {
      window.location.href = `${DataUrlLink}`;
    }
    setTimeout(() => {
      // localStorage.clear();

      return (
        JSON.parse(localStorage.getItem("user")) || {
          logged: false,
        }
      );
    }, 1500);

    dispatch({
      type: types.AuthLogout,
    });

    setOpenLoading(false);
  };
  const menuId = "primary-search-account-menu";

  const renderMenu = (
    <Menu
      id="simple-menu"
      anchorEl={anchorEl}
      keepMounted
      open={Boolean(anchorEl)}
      onClose={handleMenuClose}
    >
      {/*<MenuItem onClick={handleMenuClose}>Perfil</MenuItem>
      <MenuItem onClick={handleMenuClose}>Tu cuenta</MenuItem>*/}
      <MenuItem>
        {" "}
        <img
          src={process.env.PUBLIC_URL + "/static/imagen/userLogin.jpg"}
          className={(classes.avatar, classes.largeAvatar)}
          width="50px"
          title={"Conectado como:" + { NomberUser }}
          alt={"Conectado como:" + { NomberUser }}
        />{" "}
        <br />
        <p style={{ textDecoration: "none", paddingLeft: "5px" }}>
          Conectado(a) como:
        </p>
        <b
          style={{
            textDecoration: "none",
            color: "#1565c0",
            paddingLeft: "5px",
          }}
        >
          {NomberUser}
        </b>
      </MenuItem>
      {DataProducts && DataProducts.length > 0 ? (
        <MenuItem onClick={handleLogoutProducts}>
          <ArrowBackIcon /> &nbsp; Ir a principal
        </MenuItem>
      ) : (
        <MenuItem onClick={handleLogout}>Cerrar sesión</MenuItem>
      )}
    </Menu>
  );

  return (
    <>
      <AppBar
        position="fixed"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: open,
        })}
      >
        <Toolbar
          style={{
            backgroundImage: `url(${
              process.env.PUBLIC_URL + "/static/imagen/fondo.jpg"
            })`,
          }}
        >
          {/*boton hamburguesa */}
          {!isMobile ? (
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              className={clsx(classes.menuButton, {
                [classes.hide]: open,
              })}
            >
              <NotesIcon />
            </IconButton>
          ) : (
            ""
          )}

          {isMobile && DataProducts &&
            DataProducts?.map((dProducts, id) =>
              dProducts.Nombre == "Informe Plus" ||
              dProducts.Nombre == "Informe Plus Pre Pago" ? (
                <IconButton key={id} color="inherit" disabled={true}>
                  <Tooltip title={dProducts.Nombre}>
                    <img
                      src={
                        process.env.PUBLIC_URL +
                        `/static/imagen/${dProducts.ImagenOff.split("/")[1]}`
                      }
                      style={{ width: "40px", height: "40px" }}
                      alt="Icono Producto"
                      onClick={handleLogoutDos}
                    />
                  </Tooltip>
                </IconButton>
              ) : (
                <IconButton
                  key={id}
                  color="inherit"
                  disabled={dProducts.Vigente ? false : true}
                >
                  {dProducts.Vigente ? (
                    <a
                      href={
                        dProducts.Url +
                        "?SKL=" +
                        JSON.parse(localStorage.getItem("skl"))
                      }
                    >
                      <Tooltip title={dProducts.Nombre}>
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            `/static/imagen/${dProducts.ImageOn.split("/")[1]}`
                          }
                          style={{ width: "40px", height: "40px" }}
                          alt="Icono Producto"
                          onClick={handleLogoutDos}
                        />
                      </Tooltip>
                    </a>
                  ) : (
                    <Tooltip title={dProducts.Nombre}>
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          `/static/imagen/${dProducts.ImagenOff.split("/")[1]}`
                        }
                        style={{ width: "40px", height: "40px" }}
                        alt="Icono Producto"
                        onClick={handleLogoutDos}
                      />
                    </Tooltip>
                  )}
                </IconButton>
              )
            )}
          {DataUrl ? (
            <a href={DataUrlLink}>
              <IconButton color="inherit">
                <Tooltip title="home">
                  <img
                    src={process.env.PUBLIC_URL + `/static/imagen/home2.png`}
                    style={{ width: "40px", height: "40px" }}
                    onClick={handleLogoutUrl}
                    alt="Icono Producto"
                  />
                </Tooltip>
              </IconButton>
            </a>
          ) : (
            ""
          )}

          <div className={classes.grow} />
          <div className={classes.sectionDesktop}>
            <IconButton
              aria-label="show 4 new mails"
              className={classes.colorIconos.main}
              onClick={RedirigirSoporte}
            >
              <Badge badgeContent={0} color="primary">
                <MailIcon />
              </Badge>
            </IconButton>

            {/* <IconButton aria-label="show 17 new notifications" className={classes.colorIconos.main}>
              <Badge badgeContent={0} color="primary">
                <NotificationsIcon  />
              </Badge>
            </IconButton>*/}
            <IconButton
              edge="end"
              aria-label="account of current user"
              aria-controls={menuId}
              aria-haspopup="true"
              onClick={handleProfileMenuOpen}
              className={classes.colorIconos.main}
            >
              <AccountCircle />
            </IconButton>
          </div>
        </Toolbar>

        {renderMenu}
      </AppBar>
    </>
  );
};

export default NavBar;
